/*==========================================================
INITIALIZE HOMEPAGE SCRIPT
==========================================================*/
$(document).ready(function () {
    if (!iCreateObject.isSiteInICreateMode || iCreateObject.isSiteInPreviewMode) {
        //hide contentHome if no content
        if ($('#contentHome').text().trim().length === 0) {
            $('#contentHome').hide();
        }
    }
});


/*==========================================================
    HOMEPAGE BANNER VIDEO
==========================================================*/

$(document).ready(function() {
    $(".pauseButton").on('click',function() {
        var vid = $("#backgroundVideo")[0];
        if (!vid.paused) {
            vid.pause();
            $(this).find('.assistiveTech-only').text('Play');
            $(".pauseButton").addClass("paused");
            $(".pauseButton").text('Play Video')
        } else {
            vid.play();
            $(this).find('.assistiveTech-only').text('Pause');
            $(".pauseButton").removeClass("paused");
            $(".pauseButton").text('Pause Video')
        }
    })

    $(".toggleSound").on ('click', function () {
        var vid = $("#backgroundVideo")[0];
        if (!vid.muted) {
            vid.muted = true;
            $(".toggleSound").removeClass("sound");
        }
        else {
            vid.muted = false;
            $(".toggleSound").addClass("sound");
        }
    })
});
function moveVideoPopout() {
    //ensure .videoContentTarget is empty, if so append the .videoModalWrapper content
    if ($('.videoContentTarget').children().length == 0) {
        //moving videos to right location
        $('.videoModalWrapper').detach().appendTo('.videoContentTarget');
        //show hidden video content
        $('.videoModalWrapper').removeClass('hide');
    }
}
$(document).ready(function() {
    if ($('.videoContainer_slider').length) {
        // enable video slider
        $('.videoContainer_slider').flickity({
            // options
            cellAlign: 'center',
            contain: true,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            draggable: false,
            imagesLoaded: true,
            on: {
                ready: function () {
                    $('.videoContainer_slider .slide').each(function (index) {
                        $('.flickity-page-dots').append('<button class="dot">Slide ' + (index + 1));
                    });
                    $('.flickity-page-dots .dot').on('click', function () {
                        var index = $(this).index();
                        $('.videoContainer_slider').flickity('select', index);
                    });
                    $('.flickity-page-dots .dot:first-of-type').addClass('is-selected');
                },
                change: function (index) {
                    $('.flickity-page-dots .dot').removeClass('is-selected');
                    $('.flickity-page-dots .dot:nth-of-type(' + (index + 1) + ')').addClass('is-selected');
                }
            }
        });

        moveVideoPopout();
    }
});
/*==========================================================
      RESPONSIVE IFRAME
    ==========================================================*/

    if (!iCreateObject.isSiteInICreateMode || iCreateObject.isSiteInPreviewMode) {
        if ($('iframe').length > 0) {
            $('iframe').each(function(index) {
                var patternVideo = /(youtube\.com|youtu\.be|vimeo\.com)/,
                    video = patternVideo.test($(this).attr('src'));
                var patternIssuu = /(issuu\.com)/,
                    issuu = patternIssuu.test($(this).attr('src'));
                if (video) {
                    var iframeWidth = $(this).outerWidth(),
                        iframeHeight = $(this).outerHeight(),
                        iframePadding = iframeHeight / iframeWidth * 100;
                    if ($(this).parent('.iframe-container').length == 0) {
                        $(this).wrap('<div class="iframe-container" />');
                    }

                    $(this).parent('.iframe-container').css('padding-bottom', iframePadding + '%');
                    if ($(this).attr('width')) {
                        if (!$(this).attr('width').match('%$')) {
                            $(this).parent('.iframe-container').wrap('<div class="iframe-container-wrapper" style="max-width:' + $(this).attr('width') + 'px"></div>');
                        }
                    }
                } else if (issuu) {
                    var iframeWidth = $(this).outerWidth(),
                        iframeHeight = $(this).outerHeight(),
                        iframePadding = iframeHeight / iframeWidth * 100;
                    $(this).parent('.issuuembed').addClass('iframe-container').css('padding-bottom', iframePadding + '%');
                }
            });
        }
    }

    $(window).load(function() {
		$('.twitterBox .carousel .SMDropdownInner').flickity({
			// options
			cellAlign: 'center',
			contain: true,
			wrapAround: true,
            prevNextButtons: true,
            pageDots: false,
			autoPlay: 5000,
			cellSelector: '.tweet',
            on: {
                ready: function() {
                    // Add pause button
                    $('.twitterBox .flickity-prev-next-button.previous').wrap('<div class="flicktyControls"/>');
                    $('.twitterBox .flickity-prev-next-button.next').detach().appendTo('.flicktyControls');
                    var pause = '<button class="flickity-button pause" type="button" aria-label="Pause alert carousel" aria-selected="false"></button>';

                    $(pause).insertAfter('.twitterBox .flickity-prev-next-button.previous');

                    $('#SMWrapper .tweet.carousel-cell a').attr("tabindex", -1);
                    $('#SMWrapper .tweet.carousel-cell.is-selected a').each(function () { $(this).removeAttr('tabindex'); });
                },
                change: function( index ) {
                    $('#SMWrapper .tweet.carousel-cell a').attr("tabindex", -1);
                    $('#SMWrapper .tweet.carousel-cell.is-selected a').each(function () { $(this).removeAttr('tabindex'); });
                }
              }
		});

        $('.twitterBox .flickity-button.pause').on('click', function() {
			let isPaused = $(this).attr('aria-selected') === 'true' ? true : false;

			$(this).attr('aria-selected', isPaused ? 'false' : 'true');
			$('.twitterBox').flickity(isPaused ? 'playPlayer' : 'stopPlayer');
        });

        //Scroll to Anchor links on page load when anchor hash is part of URL
        if (window.location.hash) {
            var hash = window.location.hash.substring(1),
                hashIsEl = true;
            if ($('[name=' + hash + ']').length > 0) {
                hash = $('[name=' + hash + ']');
            } else if ($('#' + hash).length > 0) {
                hash = $('#' + hash);
            } else {
                hashIsEl = false;
            }
            if (hashIsEl) {
                headerHeight = $("header").height() + 5; // Get fixed header height
                var offsetTop = hash.offset().top - headerHeight;
                $('html, body').animate({
                    scrollTop: offsetTop
                }, 1000);
            }
        } else {
            // Scroll to #pageHeading and by pass interior banner if loading a page from the same/current vertical
            var loc = window.location.pathname;
            var referrer = document.referrer.replace(/^.*\/\/[^\/]+/, '');

            var currentDir = loc.substring(0, loc.lastIndexOf('/'));
            var referrerDir = referrer.substring(0, referrer.lastIndexOf('/'));


            if ($('#uber').hasClass('interior')) {
                if (referrerDir.toLowerCase() == currentDir.toLowerCase()) {
                    headerHeight = $("header").height() + 5; // Get fixed header height
                    var offsetTop = $('#pageHeading').offset().top - headerHeight;

                    $('html, body').animate({
                        scrollTop: offsetTop
                    }, 1000);
                }
            }
        }
    });
